import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBestPortfolioEventsGroup } from '../../api/fetch-best-portfolio-events-group';

export const fetchBestPortfolioEventsGroupThunk = createAsyncThunk(
    'fetchBestPortfolioEventsGroup',
    async () => fetchBestPortfolioEventsGroup(),
);
